/**
 * @module portal\app
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Provide } from "vue-property-decorator";

@Component
export default class App extends Vue {
  @Provide()
  private sysBus = new Vue();
}
